<template>
  <div class="mhome fx-fs-c-c">
    <a
      href="https://www.xuezhangmen.com"
      target="_blank"
      class="back-xuezhangmen"
      v-if="!isMiniProgram"
    >
      <img src="../assets/icon-back.png" alt="" />
      <span>返回学掌门</span>
    </a>
    <img class="page-img" src="../assets/mindex/linux_01.png" alt="" />
    <img class="page-img" src="../assets/mindex/linux_02.png" alt="" />
    <img class="page-img" src="../assets/mindex/linux_03.png" alt="" />
    <img class="page-img" src="../assets/mindex/linux_04.png" alt="" />
    <img class="page-img" src="../assets/mindex/linux_05.png" alt="" />
    <img class="page-img" src="../assets/mindex/linux_06.png" alt="" />
    <img class="page-img" src="../assets/mindex/linux_07.png" alt="" />
    <img class="page-img" src="../assets/mindex/linux_08.png" alt="" />
    <img class="page-img" src="../assets/mindex/linux_09.png" alt="" />
    <img class="page-img" src="../assets/mindex/linux_10.png" alt="" />
    <div class="kcdg fx-fs-c-c">
      <div class="tit-box fx-c-c">
        <img src="../assets/mindex/tit-icon.png" alt="" />
        <span class="tit">课程大纲</span>
        <img src="../assets/mindex/tit-icon.png" alt="" />
      </div>
      <div class="kcdg-in fx-fs-c-c">
        <div class="item" v-for="(item, index) in kcdg" :key="item.name">
          <div class="item-tit fx-fs-c" @click="jdIndex = index">
            <span class="jieduan">{{ item.jd }}</span>
            <span class="tittle">{{ item.name }}</span>
          </div>
          <div class="con-box fx-fs-c-c" v-show="jdIndex == index">
            <div style="padding: 0 0.35rem">
              <p class="pxmb">培训目标</p>
              <p class="mb-item" v-html="item.more.target"></p>
            </div>

            <div
              style="padding: 0.28rem 0.13rem 0"
              v-for="itemIn in item.more.detail"
              :key="itemIn.name"
            >
              <div class="course-name">{{ itemIn.name }}</div>
              <p
                class="detail-item"
                v-for="(detail, index) in itemIn.list"
                :key="index"
              >
                {{ detail }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img class="page-img" src="../assets/mindex/linux_12.png" alt="" />
    <globalFooter v-if="!isMiniProgram"></globalFooter>
  </div>
</template>
<script>
import globalFooter from '@/components//footer.vue'
export default {
  name: 'Home',
  metaInfo: {
    title: 'Linux云计算运维工程师就业培训课程-学掌门Atstudy网校',
    meta: [
      {
        name: 'keywords',
        content:
          'Linux云计算培训课程,Linux操作系统,数据库,分布式和微服务,Python自动化运维,软件实施工程师,数据库工程师,自动化运维工程师,学掌门Atstudy网校,就业培训'
      },
      {
        name: 'description',
        content:
          '学掌门的Linux云计算课程为每一个技术点精心设计典型的、易于理解的案例场景，先演示场景，再与学生互动解决思路、解决方案，最后操作实现方案。避免脱离业务场景的纯理论学习和照本宣科。'
      }
    ]
  },
  components: { globalFooter },
  data() {
    return {
      jdIndex: 0,
      respons: [
        {
          img: require('../assets/zz1.png'),
          name: '监控<br/>系统和网站'
        },
        {
          img: require('../assets/zz2.png'),
          name: '确保<br/>系统稳定性'
        },
        {
          img: require('../assets/zz3.png'),
          name: '故障处理'
        },
        {
          img: require('../assets/zz4.png'),
          name: '灾难保障'
        },
        {
          img: require('../assets/zz5.png'),
          name: '安全恢复'
        },
        {
          img: require('../assets/zz6.png'),
          name: '文档撰写'
        }
      ],
      kcdg: [
        {
          jd: '阶段一',
          name: 'Linux操作系统 (21天)',
          more: {
            target:
              '1：熟练掌握Linux常用命令、文件管理、用户组管理、权限管理、编辑器使用。<br/>2：熟练掌握Linux虚拟化技术、磁盘分区、阵列、热备、网络模式、各类工具的使用。<br/>3：熟练掌握在Linux环境下部署软件的生产环境、集群化部署方案、持续集成。',
            detail: [
              {
                name: 'Linux核心(3天）',
                list: [
                  'Linux发展史、Vmware安装MobaXterm安装部署Centos7的镜像',
                  'Vmware-桥接模式、NAT模式仅主机模式克隆虚拟主机、快照、MoBaXterm连接虚拟机',
                  'Linux操作系统启动流程讲解、Linux系统目录功能讲解',
                  'VIM-工作模式、基本应用、进阶应用、命令总结',
                  '主机名配置、帮助命令目录操作、文件操作操作目录、权限命令、进程管理、压缩和解压缩',
                  '系统监视概述top命令mpstat命令、vmstat命令iostat命令、新能分析标准运维小细节',
                  'Linux软件包－软件包的特点、源码包的特点、二进制包的特点、RPM包的安装与升级、RPM包的查询、RPM包的卸载RPM包的校验与数字证书、RPM包的文件提取',
                  'YUM -工作原理企业案例、优先级配置、构建YUM本地源构建YUM网络源、同步外网YUM源',
                  '特性及组件、单元类型、单元的配置文件语法、相关工具',
                  'root密码－单用户模式修改root密码、救援模式修改root密码、破解root密码',
                  'Linux用户管理－用户命令汇总、skel目录详解、login.defs配置文件详解、useradd文件详解、与用户相关的文件',
                  'Linux用户管理－用户组命令groupadd、密码相关命令passwd、修改用户密码有效期、删除用户、删除用户组、用户查询',
                  'Linu对又限－数字权限、字母权限、chown属主和属组管理、特殊权限SUID SGIDSBIT详解、ALC权限设置',
                  'Linux身份-身份切换命令su、sudo、企业生产环境用户权限集中管理方案',
                  '磁盘分区简介主分区、扩展分区和逻辑分区、swap交换分区',
                  '场景介绍、LVM逻辑创建XFS格式扩容 ext4格式扩容、LVM逻辑卷删除',
                  '列介绍创建模拟损坏阵列、奇偶校验和热备盘创建'
                ]
              },
              {
                name: 'Linux虚拟化(5天）',
                list: [
                  '服务搭建映射、服务补充',
                  'ftp模式介绍、vsftpd匿名用户模式配置、vsftpd本地用户模式配置、用户列表管控',
                  '服务部署、写入权限问题的解决方案开机自动挂载',
                  'NTP时间服务介绍及部署、 定时同步及同步外网',
                  '工作原理介绍、服务部署使用详解',
                  'cobbler自动化安装系统使用详解、cobbler实现安装不同操作系统',
                  '配置文件详解、反向代理、负载均衡、LNMP架构动态上线',
                  'tomcat启动和关闭、多实例部署、集群搭建、上线动态网站',
                  'GPT生成服务器配置文件',
                  'GPT模拟Nginx,自动化部署',
                  'GPT模拟Tomcat,自动化部署'
                ]
              },
              {
                name: 'Linux网络与服务(6天*4小时）',
                list: [
                  '网络协议、路由器、交换机、VLAN虚拟局域网、IP地址、Mac地址、Port端口',
                  '网络状态管理网络通讯、静态路由、动态路由',
                  '日志管理系统日志、Rsyslog日志、Logrotate日志轮转',
                  '计划任务、Crontab使用、SSH远程连接服务、SSH加密认证',
                  'Samba服务搭建、Samba映射、Samba服务操作',
                  'FTP模式、VsFtpd匿名用户模式、VsFtpd本地用户模式、用户列表管控',
                  'NFS服务部署、NFS服务写入权限、NFS开机自动挂载',
                  'NTP时间服务部署NTP定时同步NTP同步外网',
                  'DHCP服务部署DHCP服务操作',
                  'Cobbler自动化安装Cobbler安装各类操作系统',
                  'Nginx搭建、Nginx配置Nginx反向代理Ngin焕载均衡',
                  'LNMP生产环境搭建、LNMP产品上线',
                  'Tomcat搭建与配置Tomcat多实例部署Tomcat集群部署Tomcat产品上线',
                  '域名申请域名备案、域名解析、DNS客户端测试工具'
                ]
              },
              {
                name: 'Linux Shell(3天*4小时）',
                list: [
                  'shell介绍grep、cut、sort、uniq、seq、tr等命令用法详解',
                  '变量介绍变量的使用',
                  '条件表达式if条件判断、if嵌套',
                  'for循环语句详解、while循环语句详解、break和continue用法讲解',
                  'shell函数介绍、基础正则和扩展正则详解、sed用法详解 awk用法详解',
                  'GPT生成相应的Shell功能脚本',
                  'GPT检查Shell脚本规范'
                ]
              },
              {
                name: 'Linux部署与负载(2天）',
                list: [
                  '插件安装、安装部署、凭证创建及使用说明、项目简单演示',
                  'iptables常用使用详解、SNAT的使用、DNAT的使用',
                  'LVS负载均衡使用详解',
                  'keepalived介绍、配置、使用演示、nginx + KeepAlived使用演示',
                  'GPT监控LVS负载情况',
                  'GPT生成Jenkins配置文档'
                ]
              }
            ]
          }
        },
        {
          jd: '阶段二',
          name: '数据库（9天）',
          more: {
            target:
              '1：熟练使用MySQL数据库产品的DCL、DDL、DML、DQL操作。<br/>2：熟练使用Oracle数据库产品的DCL、DDL、DML、DQL操作。<br/>3：熟练掌握各类数据库产品的主从部署方案、主从复制、主从同步、读写分离技术。',
            detail: [
              {
                name: 'MySQL数据库(5天*4小时）',
                list: [
                  'MySql8的安装与初始化过程后期设置与简单操作 MySqlS.7安装与初始化后期设置与简单操作场景介绍、mysqldump、tar与cp、xtrabackup、mysqlbackup',
                  '主从复制概念与常见拓扑结构、主从复制的同步方式、环境准备过程、复制常用参数、配置操作演示',
                  'MyCat产品特性与功能介绍、安装与启动、读写分离配置过程',
                  'MySql数据库Sql基础介绍、创建与常规操作、类型与日期、表的创建与管理、表的增删改查',
                  'GPT自动生成MySql备份，自动恢复',
                  'GPT自动生成Sql操作语句'
                ]
              },
              {
                name: 'Oracle数据库(4天*4小时）',
                list: [
                  'Oracle版本介绍Oracle安装、物理结构、逻辑结构、SGA、PGA、进程',
                  'Oracle数据库实例管理、Oracle参数文件管理、Oracle控制文件管理',
                  'Oracle重做日志Oracle归档模式Oracle表空间Oracle数据文件',
                  'Oracle用户管理、Oracle网络监听配置OracleEM管理工具',
                  'Oracle备份与恢复Oracle日常检查故障分析、性能优化',
                  'Oracle数据库集群容灾高可用技术、Oracle项目实战'
                ]
              }
            ]
          }
        },
        {
          jd: '阶段三',
          name: 'python自动化运维（10天）',
          more: {
            target:
              '1：熟练掌握Python编程语言，培养扎实、规范的Python编码功底。<br/>2：熟练各类Python数据处理方式，生成各类结构数据报表。<br/>3：熟练使用Python爬虫技术、Selenium自动化工具。',
            detail: [
              {
                name: 'Python敏捷编程(3天*4小时）',
                list: [
                  'Python3下载安装，pycharm的安装、第—个Python程序、Python中的变温',
                  '基础数据类型、转换、运算',
                  '列表多元素的提取、添加、修改、删除、字典的操作详解',
                  '基本的逻辑控制语句if_else',
                  'for循环遍历和操作列表、continue和break',
                  '函数的创建和调用、函数内局部变量、全局变量使用技巧',
                  '列表字典字符串、数字类型的相互转换'
                ]
              },
              {
                name: 'Python数据猎人(7天*4小时）',
                list: [
                  '安装使用结巴分词',
                  '正则表达式详解',
                  '通过结巴、计数器对报告进行词频统计',
                  '词频统计生成词云图片',
                  '熊猫处理Excel实例详解',
                  '熊猫处理全僵数据－列表生成',
                  '熊猫处理全量数据生成DataFrame',
                  '熊猫处理全量数据操作分组数据',
                  'Python使用Openpyx操作Excel数据详解',
                  'Python使用Pyecharts制作统计图详解',
                  'Python爬虫详解、实际操作演示、自动化Selenium操作详解',
                  'GPT模拟结巴分词 提取相关数据',
                  'GPT模拟熊猫数据框架对数据进行分析',
                  'GPT模拟爬虫获取网络数据',
                  'GPT模拟Selenium自动化操作'
                ]
              }
            ]
          }
        },
        {
          jd: '阶段四',
          name: '自动化运维（12天）',
          more: {
            target:
              '1：熟练棠握Ansible常用命令、AdHoc语法、Playbook语法、Playbook集群部署方案。<br/>2：熟练掌握Ansible对各类常用产品的部署方案及配置信息。<br/>3：熟练掌握Ansible-Role部署集群环境、基础模块、应用模块、业务引入。',
            detail: [
              {
                name: 'Ansible',
                list: [
                  '场景介绍、功能特性基础架构、安装、配置文件介绍、配置文件优先级、inventory基本应用、实战用户管理被控端',
                  '命令语法、执行流程状态、配置场景、常用模块说明',
                  'command、yum copy、systemd、file、 group、User、Mount、cron、get_url、Unarchive',
                  '基本介绍、与AD-HOC的区别、管理NFS服务、管理Rsync服务端、管理Rsync客户端',
                  '项目环境准备管理Redis服务Nginx负载均衡升级Nginxt办议、替换Nginx为Haprox',
                  'Variables变量介绍、定义方式、Playbook定义变量、inventory;清单文件定义变量、host-vars定义变量、group-vars定义变量外置传递参数定义变量变量优先级、NFS改造为变量方式',
                  '场景介绍、变量语法示例、基于IP生成Redis配置、基千CPU生成Nginx配置、基于内存生成Memcache配置、优化－关闭facts、优化-redis缓存',
                  'Register-获取被控端端口信息批量修改主机名称、创建JMS相关ke 、',
                  'when、loop、Hadlers Include部署Tom、ignore_errors、forec_handlers、changed_when、vault',
                  '场景介绍、生成Nginx配置、生成haproxy配置、判断生成Keepalived',
                  '场景介绍、编排NFS服务、编排Rsync服务、部署集群环境架构图、服务器整体规划、基础环境准备、网络配詈初始化、防火墙管理、用户管理、yum仓库管理、基础软件包管理、文件描述符管理、内核模块管理、模块测试',
                  'NFS服务、Mysql服务、Redis服务、Nginx服务、PHP服务、Haproxy服务、KeepAlived服务、LVS服务、Route服务、DNS服务、Wordpress-web、Wrodpress-prox、Wordpress-keep、Wordpress-LVS'
                ]
              }
            ]
          }
        },
        {
          jd: '阶段五',
          name: '分布式和微服务（26天）',
          more: {
            target:
              '1：熟练掌握Redis的持久化配置缓存淘汰配置、各类部署方案，主流MQ消息队列产品的集群化部署配置。<br/> 2：熟练掌握ELK工具的数据采集、数据分析、日志追踪方案。<br/>3：熟练掌握Docker应用容器镜像的制作、K8S运用。',
            detail: [
              {
                name: 'Redis(2天）',
                list: [
                  'Redis安装及配置、Redis适用场景、Redis持久化机制',
                  'Redis过期删除策略、Redis缓存淘汰策略',
                  'Redis主从部署方案RedisSentine哨兵部署方案、RedisCluste集群部署方案'
                ]
              },
              {
                name: 'ELK数据采集分析(12天*4小时）',
                list: [
                  '没有日志分析工具存在的痛点、ELK基础架构解析、ELFK基础架构解析',
                  '安装、配置、调试、相关属于、文档、索引、字段、操作Curl、操作Kibana、索引API',
                  '基本概念、环境搭建、状态检查Curl、Cerebra、角色、分片与副本、故障转移、文档路由、创建流程、扩展Data节点、扩展路由节点、内核优化、配置优化、JVM优化',
                  'FileBeat-基本概念、配置解读、基本应用、写入数据到ES集群、定义索引名称、设置分片副本、系统日志、字段处理收集nginx访问日志普通格式、json格式、错误日志、多虚拟主机日志、手机-tomcat访问日志、错误日志、多虚拟主机tomcat节点日志',
                  'Logstash-日志处理基本介绍基础架构、安装与配置',
                  'Logstash-插件-Input插件、filter-grok插件、filter-geoip插件、filter-date插件、filter-useragen插件、filter-mutate插件',
                  'App业务日志-Filebeat配置Logstash配置、Kibana配詈、Nginx日志－介绍、logstash配置、Filebeat配置、Nginx-Kibana展示Mysql慢日志介绍、Filebeat配置、Logstash配置、Kibana展示',
                  'Kibanan-日志分析基本架构、指标说明日志用例、指标数据图、水平条形图标签云、时间序列、图形汇聚访问控制－基于Ngxin、基于RBAC',
                  '引入消息队列、解决耦合度问题、解决性能问题、引入Redis-Filebeat配置、Logstash配置',
                  '日志告警ElastAlert环境准备、ElastAlert接入钉钉、404告警场景、延迟告警场景',
                  'GPT模拟Zookeepe滇群部署',
                  'GPT模拟Kafka-eagle监控',
                  'GPT模拟ElastAlert环境部署404告警'
                ]
              },
              {
                name: 'MQ消息队列(2天）',
                list: [
                  'MQ-基本概念、分类、使用场景介绍、异步',
                  'MQ-kafka基本概念、基本架构、安装与调试、模拟生产者和消费者、单播消费者模拟',
                  'MQ-kafka-集群-Zookeeper集群部署',
                  'MQ-kafka-集群-kafka-eagle安装、kafka-eagle监控JVM、集群容错验证'
                ]
              },
              {
                name: 'Docker应用容器(7天*4小时）',
                list: [
                  '简介、功能特性与应用场景',
                  '安装标准安装、CE安装、更改默认数据目录',
                  'attach、build、commit、cp、create、diff、events、exec、export、history、images、import、info、inspect、kill、load、login、logout、logs、pause、port、ps、pull and push、rename、restart、rm、rmi、run、save、search、start、starts、stop、tag、top、update、version and wait',
                  'config、container、image、node plugin se、service、指令介绍',
                  '镜像制作-Dockfile编写官方镜像库的使用、Centos 7镜像制作与运行、基于Alpine的JRE和Tomcat镜像制作与运行、MySQLS.6镜像制作与运行、Redis镜像制作与运行、MongoDB镜像制作与运行',
                  '私有镜像Harbor简介、使用DNSMASQ快速搭建DNS服务签发域名证书、信任自签发的域名证书、Harbor1.4版本配置与安装漏洞扫描和镜像签名、镜像复制与同步',
                  '环境准备修改配置启动Harbor、Keepalived安装与配置OpenLDAP安装与配置OpenLDAP创建组织架构与Harbor',
                  '场景介绍、环境准备安装与磁盘准备repo替换、Ceph安装与配置创建存储池和文件系统挂在cephfs文件系统 Ceph集群扩容、集群增加节点和OSD'
                ]
              },
              {
                name: 'K8S容器分布式架构(3天）',
                list: [
                  'K8S-概念-K8S应用领域、K8S的优势K8S架构、K8S工作节点组件介绍、K8S核心资源介绍',
                  'K8S-kubeadm-实现环境规划、配置IP和主机名、配置防火墙和Yum源、配置ipvs',
                  'K8S集群安装和配置Docker、准备K8S命令行工具、配置Keepalived和nginx、初始化集群、扩容K8S添加Master节点添加Node节点',
                  'K8S-安装和调试－安装calico网络插件、调试K8S集群网络、部署业务pod、coredns域名解析'
                ]
              }
            ]
          }
        },
        {
          jd: '阶段六',
          name: '系统监控和虚拟化（18天）',
          more: {
            target:
              '1：熟练使用Zabbix系统监控、自动报警、自定义宏、故障自动处理，掌握分布式监控部署方案。<br/>2：熟练使用KVM网络配置、迁徙方案、各类集群化部署方案、嵌套虚拟化方案、备份与恢复方案。<br/>3：熟练掌握VmwarevSphere虚拟化平台角色和权限、备份还原与监控、模板克隆和快照的使用。',
            detail: [
              {
                name: 'Zabbix系统监控(5天*4小时）',
                list: [
                  'Zabbix版本介绍、server的安装、配置、调试',
                  'Zabbix配置MariaDB',
                  'Zabbix安装WebGUI、GUI界面初始化、自定义监控模板',
                  'Zabbix监控Linux用户账号和密码、自定义Triggers、自定义Discovery',
                  'Zabbix监控Nginx+FPM、软链接、监控自动化工具',
                  'Zabbix-Server配置参数的详解、高级参数详解、Screen',
                  'Zabbix监控邮件系统、邮件自动报警、使用Python自动脚本、邮件报警演示',
                  'Zabbix宏定义、开机自启动、自定义宏讲解、宏补充及Agent配詈',
                  'Zabbix自定义监控接口讲解、自定义监控接口参数演示',
                  'Zabbix监控故障自动处理、执行命令、Ansible批量部署',
                  'Zabbix分布式监控讲解、演示、性能优化',
                  'Zabbix源码编译-MySQL/Agent、安装Server、DB配置、Prox和Ansible批量开机自启',
                  'Zabbix-HOS下部署ZabbixAgent、results register、HOST批量创建、信息获取、templates、Ansible Role演示',
                  'GPT生成Zabbix-Server的配置文件',
                  'GPT模拟Zabbix-Server监控邮件，自动报警'
                ]
              },
              {
                name: 'KVM 虚拟化(7天*4小时）',
                list: [
                  '配置网卡、配置Lan、配置网络过滤、迁徙概述、静态迁移、共享存储的动态迁移、本地存储的动态迁移',
                  'P2V和V2V迁徙方案概述、准备宿主机、物理机迁徙到虚拟机、虚拟机迁徙到物理机',
                  'HA群集-Pacemaker + Corosync的Ha体系结构',
                  '群集安装-规划设计、组件安装、就群集节点准备、群集的创建',
                  'NFS群集-规划设计、NFS服务器配置与迁徙、创建高可用虚拟机、配置STONITH (IPMI)',
                  'ISCSI群集-规划设计、配置ISCSI Target、配置STONITH(DISK)、配置DLM、配置CLVM、群集添加',
                  'DRBD群集-规划设计、DRBD安装与配置、双祝DRBD资源准备、配置STONITH (virtd) 、配置DLM、配置CLVM、配置GFS2、群集添加',
                  '嵌套虚拟化-原理详解、KVMS上运行KVM与ESXI、KVM运行Hyper-V',
                  '概述、Guest Agent与快照原理、virt-manager管理快照、virsh管理快照、KVM备份与恢复备份脚本',
                  'RHEL/Centos7的KVM性能特性和改进virt-manager中的性能管理、网络性能优化、存储性能优化、内存与CPU性能优化',
                  '场景介绍、部署要求、引擎安装、安装Centos7节点、安装oVirtNode节点、配詈数据中心、配詈数据及ISO域、创建Windows虚拟机、 创建Linux虚拟机及配置Ovirt Agent、上传已有KVM镜像、使用模板、角色及权限管理、备份与恢复'
                ]
              },
              {
                name: 'Vmware vSphere虚拟化平台(6天*4小时）',
                list: [
                  'vSphere-概述、资源虚拟化、ESXI概述',
                  'vSphere-虚拟机、虚拟机硬件、容器部署Storage',
                  'vSphere-vCenter-使用vCenterServe进行集中管理、部署vCenterServer、vCenterServer; 清单、角色和权限、备份还原与监控vCenter Server HA ',
                  'vSphere虚拟网络管理-标准交换机、网络策略与分布式交换机',
                  'vSphere虚拟内存管理-虚拟存储、添加ISCSI存储、vmfs与NFS数据存储',
                  'vSphere-虚拟机管理-创建模板和克隆、内容库、修改虚拟机、vMotion、EVC、StoragevMotion与快照',
                  'vSphere-资源管理-CPU、内存资源控制、资源监控工具、监控资源情况、使用报警',
                  'vSphere集群-详情介绍、DRS理论、HAJ里论、配置HA、配置FT',
                  'vSphere-生命周期管理',
                  'GPT部署vSphere-vCenter',
                  'GPT模拟vSphere-vCenter备份与监控',
                  'GPT模拟vSphere报警'
                ]
              }
            ]
          }
        }
      ],
      isMiniProgram: false,
    }
  },
  mounted() {
    const userAgent = window.navigator.userAgent.toLowerCase()
    console.log(userAgent);
    console.log(userAgent.includes('miniprogram'));
    if (userAgent.includes('miniprogram')) this.isMiniProgram = true
    console.log(this.isMiniProgram);
  },
  methods: {}
}
</script>
<style scoped lang="scss">
.mhome {
  position: relative;
  .back-xuezhangmen {
    position: absolute;
    top: 0.47rem;
    right: 0.48rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.77rem;
    height: 0.85rem;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 0.43rem;
    text-decoration: none !important;
    img {
      width: 0.17rem;
      height: 0.27rem;
      margin-right: 0.2rem;
    }
    span {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 0.35rem;
      color: #fcfcff !important;
    }
  }
  .page-img {
    width: 100%;
  }
  .kcdg {
    width: 100%;
    height: 17.88rem;
    background: #0c1c4d;
    padding: 0.67rem 0.47rem 0.73rem 0.47rem;
    .tit {
      font-size: 0.53rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      line-height: 0.53rem;
      padding: 0 0.65rem;
    }
    img {
      width: 0.8rem;
    }
    .kcdg-in {
      width: 9.07rem;
      height: 15.33rem;
      background: #ffffff;
      border-radius: 0.13rem;
      margin-top: 0.61rem;
      .item-tit {
        width: 9.07rem;
        height: 0.8rem;
        background: linear-gradient(102deg, #1741c2, #2650d0);
        border-radius: 0.13rem 0.13rem 0rem 0rem;
        padding-left: 0.48rem;
        margin-bottom: 0.08rem;
        .jieduan {
          width: 1.33rem;
          height: 0.48rem;
          background: linear-gradient(90deg, #e7fbc2, #76fdfa);
          border-radius: 0.24rem;
          font-size: 0.32rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #0d43b6;
          line-height: 0.48rem;
          text-align: center;
        }
        .tittle {
          font-size: 0.32rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          line-height: 0.8rem;
          margin-left: 0.31rem;
        }
      }
      .con-box {
        height: 10.04rem;
        overflow-y: auto;
        padding: 0.39rem 0 0.11rem;
        .pxmb {
          font-size: 0.32rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #0d43b6;
          line-height: 0.32rem;
          padding-bottom: 0.13rem;
        }
        .mb-item {
          font-size: 0.32rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #353535;
          line-height: 0.48rem;
        }
        .course-name {
          width: 8.8rem;
          height: 0.53rem;
          background: #5f8be8;
          font-size: 0.32rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          line-height: 0.53rem;
          text-align: center;
        }
        .detail-item {
          font-size: 0.32rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #232323;
          line-height: 0.48rem;
          padding: 0 0.24rem;
          &:nth-of-type(2n + 1) {
            background: #e8f1fd;
          }
        }
      }
    }
  }
}
</style>
